import React, { useCallback } from 'react';
import { View } from '@adobe/react-spectrum';
import { EditorActions } from 'app/stores/editor/actions';
import { useAppDispatch } from 'app/stores/store';
import { Editor as DesktopEditor } from 'app/views/components/editor/platform/desktop/Editor';
import { Editor as MobileEditor } from 'app/views/components/editor/platform/mobile/Editor';
import { Toast } from 'app/views/components/editor/Toast';
import { useBeforeUnload } from 'app/views/hooks/useBeforeUnload';
import { useWatermarkInfo } from 'app/views/hooks/useWatermarkInfo';
import { Capabilities } from 'app/utils/Capabilities';
import { toDomPx } from 'app/utils/DOM';
import { StaticTooltipTrigger } from '../core/DisabledTooltip';
const WatermarkToolTip = (props) => {
    const { bounds } = props;
    const dispatch = useAppDispatch();
    const onPress = useCallback(() => {
        dispatch(EditorActions.TEMPORARYsetSettingsOpened(true));
    }, [dispatch]);
    if (!bounds) {
        return null;
    }
    return (React.createElement(View, { UNSAFE_style: {
            display: 'block',
            position: 'fixed',
            left: toDomPx(bounds.x),
            top: toDomPx(bounds.y),
            width: toDomPx(bounds.width),
            height: toDomPx(bounds.height),
            background: 'transparent',
        } },
        React.createElement(StaticTooltipTrigger, { delay: 100, isOpen: true, defaultOpen: true, tooltip: "Watermark is free to remove. Click to open application settings.", onPress: onPress })));
};
const WatermarkInfo = () => {
    const watermark = useWatermarkInfo();
    if (!watermark.hovered) {
        return null;
    }
    return React.createElement(WatermarkToolTip, { bounds: watermark.bounds });
};
export const Editor = () => {
    useBeforeUnload();
    const PlatformContent = Capabilities.shared.isMobileDevice
        ? MobileEditor
        : DesktopEditor;
    const isWatermarkHidden = configGet('hideWatermarkDuringRollout', false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Toast, null),
        React.createElement(PlatformContent, null),
        !isWatermarkHidden && React.createElement(WatermarkInfo, null)));
};
